import React from 'react';
import { Link } from 'react-router-dom';
import PageNavigation from '../components/PageNavigation';
import './Page.css';

function Projects() {
  return (
    <div className="page-container">
      <PageNavigation />
      <div className="page-content">
        <p className="page-text">
          Content coming soon.
        </p>
        <Link to="/" className="back-link">← PLAY WITH THE BAGEL</Link>
      </div>
    </div>
  );
}

export default Projects;

